<template>
    <ul class="form_list">
        <li class="title">
            {{ $t('reservation_settings.popup_staff_settings.label_staff_name') }}
            <span class="red_txt">*</span>
        </li>
        <li class="cont">
            <input type="text" class="input_s w_full" :placeholder="$t('reservation_settings.popup_staff_settings.label_staff_name')" maxlength="300" v-model="title" @focus="clearError">
            <small v-if="isErrorTitle" class="red_txt">담당자명을 입력해 주세요.</small>
            <small v-if="isErrorDuplicatedTitle && isErrorTitle!=true" class="red_txt">이미 등록된 담당자입니다. 다른 이름으로 설정해 주세요.</small>
        </li>
    </ul>
</template>


<script>
export default {
    props: {
        value: String,
        isErrorTitle: Boolean,
        isErrorDuplicatedTitle: Boolean,
    },
    data() {
        return {
            title: ''
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function(newValue) {
                this.title = newValue
            }
        },
        title: {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.title)
        },
        clearError() {
            this.$emit('clearError', 'isErrorTitle')
            this.$emit('clearError', 'isErrorDuplicatedTitle')
        }
    }
}
</script>